import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-traductions',
  templateUrl: './traductions.component.html',
  styleUrls: ['./traductions.component.scss']
})
export class TraductionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
